import {useEffect, useState} from "react";
import {LiveblogCoreApi} from "../liveblog-core/LiveblogCoreWidgetProps";
import {tickarooLiveblogInitEvent} from "../events";

export function useMasterElement(liveblogId: string): Element | undefined {
  const [masterElement, setMasterElement] = useState<Element | undefined>(undefined)

  useEffect(() => {
    const findMasterElement = () => {
      const masterElement = Array.from(document.getElementsByTagName("tickaroo-liveblog"))
      .filter((el) => {
        try {
          (el as unknown as LiveblogCoreApi).getCurrentLiveblogData()
        } catch (e) {
          return false
        }
        return true
      })
      .find(x => x.getAttribute("liveblogId") === liveblogId)

      console.debug("masterElement", masterElement)
      setMasterElement(masterElement)
    }

    findMasterElement()
    window.addEventListener(tickarooLiveblogInitEvent, findMasterElement)
    return () => {
      window.removeEventListener(tickarooLiveblogInitEvent, findMasterElement)
    }
  }, [liveblogId]);

  return masterElement;
}
